import { ServiceNodeDetail } from '@bumble/app/__generated__/data-contracts';
import DataTableGrid from '@bumble/app/components/DataTableGrid';
import { Loading } from '@bumble/app/components/Loading';
import { Indicator } from '@bumble/app/components/Indicator';
import NoData from '@bumble/app/components/NoData';
import { GridColDef } from '@mui/x-data-grid';
import { DateTime } from 'luxon';

const columns: GridColDef[] = [
  {
    field: 'ep_name',
    headerName: 'EP Name',
    flex: 1,
    minWidth: 300,
    disableColumnMenu: true,
  },
  {
    field: 'ep_id',
    headerName: 'EP Id',
    width: 200,
    disableColumnMenu: true,
  },
  {
    field: 'ep_node_id',
    headerName: 'EP Node Id',
    width: 200,
    disableColumnMenu: true,
  },
  {
    field: 'admin_state',
    headerName: 'Admin State',
    width: 120,
    disableColumnMenu: true,
  },
  {
    field: 'op_state',
    headerName: 'Op State',
    width: 120,
    disableColumnMenu: true,
    renderCell: (params) => {
      return params.value !== undefined ? <Indicator active={params.value === 'up'} /> : 'N/A';
    }
  },
  {
    field: 'app_service_id',
    headerName: 'AppService ID',
    width: 200,
    disableColumnMenu: true,
  },
  {
    field: 'ip_addr',
    headerName: 'EP IP Address',
    width: 150,
    disableColumnMenu: true,
  },
  {
    field: 'created_at',
    headerName: 'EP Created at',
    minWidth: 150,
    headerAlign: 'right',
    align: 'right',
    disableColumnMenu: true,
    valueGetter: (value) => {
      if (value === null) return '';
      return DateTime.fromISO(value).toLocaleString(DateTime.DATETIME_SHORT);
    },
  },
  {
    field: 'fqdn',
    headerName: 'App DNS Name',
    width: 500,
    disableColumnMenu: true,
  },
];

const columnVisible = {
  ep_name: true,
  ep_node_id: true,
  admin_state: true,
  admin_state_change_at: true,
  op_state: true,
  op_state_change_at: true,
  fqdn: true,
  app_service_id: true,
  ip_addr: true,
  created_at: true,
};

export const ServiceNodeTabConnectedEndpoints = ({
  data,
  loading,
}: {
  data: ServiceNodeDetail | undefined;
  loading: boolean;
}) => {
  if (loading) return <Loading />;
  if (data === undefined) return <NoData />;

  return (
    <DataTableGrid
      rows={
        data?.endpoints.map((item) => {
          return {
            ...item,
            id: item.ep_id,
          };
        }) || []
      }
      columns={columns}
      columnVisibilityModel={columnVisible}
    />
  );
};
